// The player URL for a class, at a lesson when `resume` is given:
// /courses/<class>/<chapter>/<video>?lesson=<id>. The lesson id makes the
// URL unambiguous when lessons in a chapter share a video; old links
// without it still resolve by chapter + video.
export function lessonPath(courseId, resume) {
  if (!resume) return `/courses/${courseId}`;
  const id = resume.lesson_id ?? resume.id;
  return `/courses/${courseId}/${resume.chapter_id}/${resume.video}${id ? `?lesson=${id}` : ""}`;
}

export function lessonLink(courseId, lesson) {
  return lessonPath(courseId, { chapter_id: lesson.chapter_id ?? lesson.chapter.id, video: lesson.video, lesson_id: lesson.id });
}
